<div class="container mt-3">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 pb-5">
            <!--Form with header-->
            <form>
                <div class="card border-primary rounded-0">
                    <div class="card-header p-0">
                        <div class="bg-info text-white text-center py-2">
                            <h3><i class="material-icons"></i> My Vocabularies</h3>
                        </div>
                    </div>
                    <div class="card-body p-3">

                        <!--Body-->
                        <div class="form-group">
                            <div class="input-group mb-2">

                            </div>
                        </div>
                        <div class="form-group">
                            <ul>
                                <li *ngFor="let voc of vocabularies">
                                    <span class="badge">Id : {{voc.id}}</span><br/>
                                    <span class="badge">De : {{voc.word}}</span><br/>
                                    <span class="badge">Tr : {{voc.vocabularyDetail && voc.vocabularyDetail[0] && voc.vocabularyDetail[0].sentenceMeaning}}</span>
                                    <hr>
                                </li>
                            </ul>
                        </div>

                    </div>

                </div>
            </form>
            <!--Form with header-->
        </div>
    </div>
</div>